import useCheckPermission from "@/Hooks/useCheckPermission";

interface PermissionWrapperProps {
  permission?: "view" | "update" | "delete" | "create";
  children: React.ReactNode;
  featurePermission?: string;
}

const PermissionWrapper = ({
  children,
  permission,
  featurePermission = "",
}: PermissionWrapperProps) => {
  const { authService, hasPermission, hasFeaturePermission } =
    useCheckPermission();

  if (authService.isLoading) return <></>;

  if (featurePermission && hasFeaturePermission(featurePermission)) {
    return <div>{children}</div>;
  }
  if (!featurePermission && hasPermission[permission!]) {
    return <div>{children}</div>;
  }
};

export default PermissionWrapper;
